
import Vue from 'vue';

export default Vue.extend({
	name: 'SetupSessionTerms',
	props: {
		launchText: { type: String, required: true },
	},
});
